import { fabric } from "fabric";
export var boundedCanvas = function boundedCanvas(canvas) {
  canvas.on("object:moving", function (e) {
    var obj = e.target; // if object is too big ignore

    if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
      return;
    }

    obj.setCoords(); // top-left  corner

    if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
      obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
      obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
    } // bot-right corner


    if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
      obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
      obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left);
    }
  });
  return canvas;
};
export var scalableCanvas = function scalableCanvas(canvas) {
  var scale = function scale(_scale) {
    if (this.previousScale === _scale) {
      return;
    }

    if (this.previousScale) {
      var previousScale = this.previousScale;
      this.previousScale = null;
      this.scale(1 / previousScale);
    }

    this.setHeight(this.getHeight() * _scale);
    this.setWidth(this.getWidth() * _scale);
    var objects = this.getObjects();

    for (var i in objects) {
      var object = objects[i];
      object.scaleX = object.scaleX * _scale;
      object.scaleY = object.scaleY * _scale;
      object.left = object.left * _scale;
      object.top = object.top * _scale;
      object.setCoords();
    }

    this.renderAll();
    this.calcOffset();
    this.previousScale = _scale;
  };

  canvas.scale = scale.bind(canvas);
  return canvas;
};
export var filterableCanvas = function filterableCanvas(canvas) {
  var filter = function filter(filterCallback) {
    var _this = this;

    this.getObjects().forEach(function (object) {
      if (filterCallback(object) === false) {
        _this.remove(object);
      }
    });
  };

  canvas.filter = filter.bind(canvas);
  return canvas;
};
export var fourDimensionalCanvas = function fourDimensionalCanvas(canvas) {
  var alignToTime = function alignToTime(time) {
    var precisionTime = Math.round(time * 100) / 100;
    var activeObjects = this.getActiveObjects ? this.getActiveObjects() : null;
    this.getObjects().forEach(function (object) {
      if (!object.metadata) {
        object.visible = true;
        return;
      }

      var _object$metadata = object.metadata,
          start = _object$metadata.start,
          duration = _object$metadata.duration;
      var isVisible = start <= precisionTime && start + duration >= precisionTime;
      object.visible = isVisible;

      if (!isVisible && activeObjects) {
        activeObjects = activeObjects.filter(function (selectedObject) {
          return selectedObject !== object;
        });
      }
    });

    if (activeObjects && activeObjects.length !== this.getActiveObjects().length) {
      this.discardActiveObject();
      var sel = new fabric.ActiveSelection(activeObjects, {
        canvas: this
      });
      canvas.setActiveObject(sel);
    }

    this.renderAll();
  };

  canvas.alignToTime = alignToTime.bind(canvas);
  return canvas;
};
export var framedCanvas = function framedCanvas(canvas) {
  var drawFrame = function drawFrame(size) {
    var _this2 = this;

    var lightBlue = "#c4e0e4";
    var blue = "#12b2d9";
    var canvasWidth = this.width,
        canvasHeight = this.height;
    var parts = [//left side
    {
      width: size,
      height: canvasHeight,
      left: 0,
      top: 0,
      fill: lightBlue
    }, {
      width: canvasWidth * 0.3,
      height: size,
      left: 0,
      top: 0,
      fill: lightBlue
    }, {
      width: canvasWidth * 0.3,
      height: size,
      left: 0,
      top: canvasHeight - size,
      fill: lightBlue
    }, //right side
    {
      width: size,
      height: canvasHeight,
      left: canvasWidth - size,
      top: 0,
      fill: blue
    }, {
      width: canvasWidth * 0.7,
      height: size,
      left: canvasWidth * 0.3,
      top: 0,
      fill: blue
    }, {
      width: canvasWidth * 0.7,
      height: size,
      left: canvasWidth * 0.3,
      top: canvasHeight - size,
      fill: blue
    }];
    parts.forEach(function (part) {
      _this2.add(new fabric.Rect(part));
    });
  };

  canvas.drawFrame = drawFrame.bind(canvas);
  return canvas;
};